<template>
<div id="app">
    <top-navbar/>
</div>

</template>

<script>
import TopNavbar from './home/components/TopNavbar'
import {
  onBeforeUnmount,
  mount
} from "vue";
export default {
  name: 'App',
  components: { TopNavbar },
  // mounted(){
  //     // 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
  //     // window.onbeforeunload = function (e) {
  //     //   var storage = window.localStorage;
  //     //   storage.clear()
  //     // }
  //   }
  setup() {
    onBeforeUnmount(() => {
      state.esgreport.unmount()
    })
  }
}
</script>
<style src="./common/css/app.less" lang="less"></style>



// WEBPACK FOOTER //
// src/App.vue